import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UserStateService } from '../services/authentication/user-state.service';

@Injectable()
export class PermissionInterceptor implements HttpInterceptor {
  private userSession = inject(UserStateService);

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next
      .handle(httpRequest)
      .pipe(catchError((err) => throwError(() => err)))
      .pipe(
        map<HttpEvent<any>, any>((res: HttpEvent<any>) => {
          if (res instanceof HttpResponse) {
            const isImpersonateMode = res.headers.has('x-imp');
            if (isImpersonateMode && +isImpersonateMode > 0)
              this.userSession.setIsImpersonateMode(true);
            else this.userSession.setIsImpersonateMode(false);
          }
          return res;
        }),
      );
  }
}

export const HttpPermissionInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PermissionInterceptor, multi: true },
];
